import React, { Component } from 'react';

class TrimSelect extends Component {

    state = { 
        dataLoaded: false,
        year: this.props.year,
        make: this.props.make,
        model: this.props.model,
        trims: []
    }

    componentDidMount(){
        // Fetch the years
        fetch(`${process.env.REACT_APP_API_URL}/vehicleInfo/getTrims/${this.state.make}/${this.state.model}?year=${this.state.year}`, {
            method: 'GET'
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result["success"] === true) {

                        this.setState({
                            ...this.state,
                            dataLoaded: true,
                            trims: result.trims
                        })
                    } else if (result["success"] === false) { 
                        console.log("Error fetching vehicle trims.")
                    } else {
                        console.log("Error fetching vehicle trims.")
                    }
                }).catch(error => {
                    console.log("Error fetching vehicle trims.")                                      
                });  
    }

    render() { 
        return ( 
            this.state.dataLoaded ? 
                <select value={this.props.defaultValue} className="form-control" onChange={event => this.props.handleChange(this.props.questionId, event.target.value, false, true, 'trim')}>
                    <option></option>
                    {this.state.trims.map(trim => {
                        return <option value={trim}>{trim}</option>
                    })}
                </select>
            :
                <select className="form-control">
                    <option> - </option>
                </select>
        );
    }
}
 
export default TrimSelect;